import _ from 'lodash'

export const getAbstract = async ({ doi }: { doi: string }) => {
  if (_.isEmpty(doi)) {
    throw new Error('doi is empty.')
  }

  // 検索ワードから論文ID一覧を取得
  try {
    const data = await fetch(
      // '/stubs/crossrefdata.json'
      `https://api.semanticscholar.org/v1/paper/${doi}`,
      {
        // cache: 'force-cache' // NOTE: キャシュを使う場合はコメントアウトして下さい
      }
    )
    const jsonData = await data.json()
    if (jsonData.error) {
      throw new Error(jsonData.error)
    }

    return (jsonData.abstract as string) || ''
  } catch (e) {
    console.error(e)
    return ''
  }
}
